import { CommonMetaData } from "@/types/meta";
import { MonkeyReqParams } from "./types";
import { shallowCopy } from "@noli/core";

export type MonkeyMeta = {
  type: "monkey";
  data: CommonMetaData & {
    wh: { w: number; h: number };
  } & MonkeyReqParams;
};

export type FormattedMonkeyMeta = {
  type: "monkey";
  data: MonkeyMeta["data"] & {
    h: number;
    negative_prompt: string;
    num_steps: number;
    promptInfo: {
      original: string;
      originalNegative: string;
    };
    seed: number;
    text: string;
    timestamp: number;
    w: number;
  };
};

export const formateMeta = (meta: MonkeyMeta): FormattedMonkeyMeta => {
  const { width, height, prompt, negative_prompt, sampling_step, seed } = meta.data.params;
  const newMeta = shallowCopy(meta) as unknown as FormattedMonkeyMeta;
  newMeta.data = {
    ...newMeta.data,
    h: height,
    w: width,
    text: prompt,
    negative_prompt,
    num_steps: sampling_step,
    seed,
    promptInfo: {
      original: prompt,
      originalNegative: negative_prompt,
    },
  };
  return newMeta;
};

/**
 * 要记得把这个 _IImportxxxMeta，引用到 src\thirdParty\meta.ts 中的 _IImportThirdPartyMeta 里头
 * 而且引用时，最好使用 import type { _IImportxxxMeta } from ... 来进行引用
 */

export type _IImportMonkeyMeta = {
  type: FormattedMonkeyMeta["type"];
  meta: FormattedMonkeyMeta;
  opt: null;
};
